import { render, staticRenderFns } from "./ClientsStatisticList.vue?vue&type=template&id=728d098e&scoped=true"
import script from "./ClientsStatisticList.vue?vue&type=script&lang=js"
export * from "./ClientsStatisticList.vue?vue&type=script&lang=js"
import style0 from "./ClientsStatisticList.vue?vue&type=style&index=0&id=728d098e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d098e",
  null
  
)

export default component.exports